<template>
  <div class="collapse">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Collapser',
  props: {
    accordion: {
      default: false,
      type: Boolean,
    },
    isRight: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    closeAllItems(el) {
      let height = '';
      this.$children.forEach(child => {
        if (child.opened && child.$el !== el) {
          height = child.$el.clientHeight;
          child.opened = false;
        }
      });
      return height;
    },
  },
};
</script>
